import { useState } from 'react'
import parse from 'html-react-parser'
import { useRef } from 'react';
import './Editor.scss'

const Editor = (({
    handleInput
}) => {
    const editorRef = useRef(null);

    const numberFormats = [
        { label: '1) ru-RU (по-русски)', format: new Intl.NumberFormat('ru-RU') },
        { label: '2) en-US (по-английски)', format: new Intl.NumberFormat('en-US') },
        { label: '3) USD', format: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }) },
        { label: '4) RUB', format: new Intl.NumberFormat('ru-RU', { style: 'currency', currency: 'RUB' }) },
        { label: '5) %', format: new Intl.NumberFormat('en-US', { style: 'percent', minimumFractionDigits: 2 }) },
        { label: '6) Убрать форматирование', format: new Intl.NumberFormat('en-US', { useGrouping: false }) },
        // { label: '7) Min 4 fraction digits', format: new Intl.NumberFormat('en-US', { minimumFractionDigits: 4 }) },
    ];

    // Функция для изменения жирности текста
    const toggleBold = () => {
        document.execCommand('bold');
    };

    // Функция для изменения курсива текста
    const toggleItalic = () => {
        document.execCommand('italic');
    };

    // Функция для изменения курсива текста
    const toggleUnderline = () => {
        document.execCommand('underline');
    };

    // Функция для изменения цвета текста
    const changeTextColor = () => {
        const color = prompt('Введите цвет для текста (например, red, #ff5733):', '');
        if (color) {
            document.execCommand('foreColor', false, color); // Изменяем цвет текста
        }
    };

    // Функция для обновления содержимого редактора
    const handleChange = () => {
        if (editorRef.current) {
            // setContent(editorRef.current.innerHTML); // Обновляем состояние содержимого редактора
        }
    };

    // Функция для записи итоговой разметки
    const saveHTML = () => {
        // setFinalHTML(editorRef.current.innerHTML); 
        // Сохраняем текущую разметку в состояние finalHTML
    };

    // Функция для добавления текста и ссылки
    const insertLink = () => {
        const url = prompt('Введите URL ссылки:', '');
        const linkText = prompt('Введите текст ссылки:', '');

        if (url && linkText) {
            // Проверяем и корректируем URL
            let finalUrl = url;
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                finalUrl = 'https://' + url;
            }

            const selection = window.getSelection();
            const range = selection.getRangeAt(0);
            const linkNode = document.createElement('a');
            linkNode.href = finalUrl;
            linkNode.target = '_blank';
            linkNode.textContent = linkText;
            linkNode.style.color = 'blue';

            range.deleteContents(); // Удаляем выбранный текст
            range.insertNode(linkNode); // Вставляем ссылку
        }
        handleInput();
    };
    // Функция для форматирования чисел
    const formatNumber = () => {
        const selection = window.getSelection();
        if (!selection.rangeCount) return;

        const selectedText = selection.toString().trim();
        if (!selectedText) {
            alert('Пожалуйста, выделите число для форматирования');
            return;
        }

        const number = parseFloat(selectedText.replace(/,/g, ''));
        if (isNaN(number)) {
            alert('Выделенный текст не является числом');
            return;
        }

        const formatOptions = numberFormats.map(f => f.label);
        const selectedFormat = prompt(`Выберите формат числа:\n${formatOptions.join('\n')}\nВведите номер формата (1-${formatOptions.length}):`, '1');

        if (!selectedFormat) return;

        const formatIndex = parseInt(selectedFormat) - 1;
        if (isNaN(formatIndex)) return;

        if (formatIndex >= 0 && formatIndex < numberFormats.length) {
            const formattedNumber = numberFormats[formatIndex].format.format(number);

            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(formattedNumber));

            handleInput();
        } else {
            alert('Неверный номер формата');
        }
    };

    return (
        <div className='editor-article'>
            {/* Жирный */}
            <button className='editor-article__btn' onClick={toggleBold}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <path d="M6 4h6a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4H6z" />
                    <path d="M6 12h6a4 4 0 0 1 4 4v0a4 4 0 0 1-4 4H6z" />
                </svg>
            </button>
            {/* Курсив */}
            <button className='editor-article__btn' onClick={toggleItalic}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <line x1="19" y1="4" x2="10" y2="4" />
                    <line x1="14" y1="20" x2="5" y2="20" />
                    <line x1="15" y1="4" x2="9" y2="20" />
                </svg>
            </button>
            {/* Подчеркивание */}
            <button className='editor-article__btn' onClick={toggleUnderline}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <path d="M6 4v6a6 6 0 0 0 12 0V4" />
                    <line x1="4" y1="22" x2="20" y2="22" />
                </svg>
            </button>
            {/* Цвет текста */}
            <button className='editor-article__btn' onClick={changeTextColor}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <path d="M5 20l7-16 7 16H5z" />
                    <line x1="9" y1="14" x2="15" y2="14" />
                </svg>
            </button>
            {/* Ссылка */}
            <button className='editor-article__btn' onClick={insertLink}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <path d="M10 13a5 5 0 0 0 7.07 0l2.83-2.83a5 5 0 0 0-7.07-7.07l-1 1" />
                    <path d="M14 11a5 5 0 0 0-7.07 0l-2.83 2.83a5 5 0 0 0 7.07 7.07l1-1" />
                </svg>
            </button>
            {/* Форматирование чисел */}
            <button className='editor-article__btn' onClick={formatNumber} title="Форматировать число">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" strokeLinejoin="round">
                    <path d="M4 19V5h16v14" />
                    <path d="M8 15h8" />
                    <path d="M8 9h8" />
                    <path d="M8 12h8" />
                </svg>
            </button>
        </div>
    )
})

export { Editor }